import { Component } from '@angular/core';

@Component({
  selector: 'app-local-loader-com',
  templateUrl: './local-loader.com.html'
})

export class LocalLoaderComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/shared/holders/local-loader/local-loader.com.ts